"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductCard = void 0;
const React = require("react");
const Currency_1 = require("../../../../../components/base/atoms/Currency");
const Button_1 = require("../../../../../components/base/atoms/Button");
const ImgBlock_1 = require("../../../../../components/base/atoms/ImgBlock");
const Product_1 = require("../../models/Product");
const ProductDietaryInfo_1 = require("../ProductDietaryInfo");
const styles = require("./styles.scss");
const cssComposer_1 = require("../../../../../helpers/cssComposer");
const css = (0, cssComposer_1.default)(styles, "ProductCard");
const ProductCard = ({ product, onClick, isUpdatingCart }) => {
    const { category: { displaySize = Product_1.TProductDisplaySize.Large }, title, imageUrl, retailPrice, description } = product;
    return (React.createElement("div", { className: css("", `-size-${displaySize}`) },
        React.createElement("div", { className: css("image_container"), onClick: onClick },
            React.createElement(ImgBlock_1.ImgBlock, { variant: "cover", className: css("image"), src: imageUrl }),
            React.createElement(ProductDietaryInfo_1.ProductDietaryInfo, { product: product }),
            React.createElement("div", { className: css("detail") },
                React.createElement("h3", { className: css("title") }, title),
                React.createElement("p", { className: css("price") },
                    React.createElement("label", null,
                        React.createElement(Currency_1.Currency, null, retailPrice))),
                React.createElement("p", { className: css("description") }, description),
                React.createElement("p", { className: css("action") }, product.isOutOfStock ? (React.createElement("span", null, "Out of stock")) : (React.createElement(Button_1.Button, { className: css("buyButton"), onClick: onClick, disableOnSuccess: false, disabled: isUpdatingCart }, "Order now")))))));
};
exports.ProductCard = ProductCard;
//# sourceMappingURL=index.js.map